import collectIdea from './collectIdea.svg';
import createProtorype from './createPrototype.svg';
import lanuchProduct from './lanuchProduct.svg';

export  {
    collectIdea,
    createProtorype,
    lanuchProduct
}



// WEBPACK FOOTER //
// ./src/assets/images/steps/index.js